import { FLOATING_MAX_WIDTH } from '@components/v2/ui/Alert/alert.styles';
import type { CSSProperties } from 'react';
import { Toaster, type ToasterProps } from 'sonner';

export const SNACKBAR_MAX_WIDTH = FLOATING_MAX_WIDTH;

type SnackbarProps = Pick<
  ToasterProps,
  | 'id'
  | 'position'
  | 'expand'
  | 'visibleToasts'
  | 'gap'
  | 'duration'
  | 'offset'
  | 'mobileOffset'
  | 'containerAriaLabel'
> & {
  width?: number;
  zIndex?: number;
};

const Snackbar = ({
  id,
  position,
  expand,
  visibleToasts,
  gap,
  duration,
  offset,
  mobileOffset,
  containerAriaLabel,
  width,
  zIndex,
}: SnackbarProps) => (
  <Toaster
    id={id}
    position={position}
    expand={expand}
    visibleToasts={visibleToasts}
    gap={gap}
    duration={duration}
    offset={offset}
    mobileOffset={mobileOffset}
    containerAriaLabel={containerAriaLabel}
    style={{ ...(width !== undefined && { '--width': `${width}px` }), zIndex } as CSSProperties}
  />
);

export default Snackbar;
